import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import AppErrorBoundary from './components/AppErrorBoundary';

// Offline-safe font stack: no npm font package and no external runtime font requests
import './index.css';
import { registerServiceWorker } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
      <Toaster 
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            fontFamily: "Tahoma, 'Segoe UI', Arial, sans-serif",
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>
);

registerServiceWorker();
